import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { AddressTitleService } from 'src/app/Service/AddressTitle/AddressTitle.service';

@Component({
  selector: 'app-AddressTitleAdd',
  templateUrl: './AddressTitleAdd.component.html',
  styleUrls: ['./AddressTitleAdd.component.scss']
})
export class AddressTitleAddComponent implements OnInit {

  Token:String=""

  constructor(
    private AddressTitle_Service:AddressTitleService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewAddressTitle=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,1122).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewAddressTitle:FormGroup;

  get_Form_Title(){
    return this.AddNewAddressTitle.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewAddressTitle(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.AddressTitle_Service.AddAddressTitle(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list")
        }
        else{
          this.AddNewAddressTitle.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



}
